import React, { useEffect, useMemo, useState } from "react";
import styles from "../models/WorkflowModels.module.css";
import HeaderRow from "./HeaderRow";
import { InfiniteList2 } from "../../../../../../common/components";
import { useApi } from "../../../../../../common/hooks";
import { AiWorkflowService } from "../../../../../../api";
import HistoryRow from "./HistoryRow";
import { translate } from "../../../../../../common/providers";
import { openHtml } from "../../../../../../common/utils";

const WorkFlowHistory = () => {
	const { call: getExecutionList } = useApi(AiWorkflowService.getExecutionList);
	const { call: downloadTrace } = useApi(AiWorkflowService.downloadTrace);
	const { call: forceCriteriaState } = useApi(AiWorkflowService.forceCriteriaState);
	const [infiniteListRequest, setInfiniteListRequest] = useState(null);
	const headers = useMemo(
		() => [
			{ name: translate("common:field.id"), className: "rowFixed" },
			{ name: translate("common:field.workflow-name"), className: "rowText" },
			{ name: translate("common:field.project-name"), className: "rowText" },
			{ name: translate("common:field.waiting-for-manual"), className: "rowText" },
			{ name: translate("common:header.filter.status"), className: "rowText" },
			{ name: translate("common:field.created"), className: "rowFixed" },
			{ name: "", className: "action" },
		],
		[]
	);
	useEffect(() => {
		setInfiniteListRequest(
			() =>
				({ page, limit }) =>
					getExecutionList({
						page,
						size: limit,
					})
		);
	}, [getExecutionList]);
	const handleDownloadTrace = (id) => {
		downloadTrace({ executionId: id })
			.then(({ data }) => {
				openHtml({ data });
			})
			.catch((err) => console.error(err));
	};
	const handleForceCriteria = (history) => {
		const { id, projectId } = history;
		if (id && projectId) {
			forceCriteriaState({ projectId, executionId: id }).then().catch(console.error);
		}
	};
	const rowRenderer = (history) => (
		<HistoryRow
			key={history.id}
			history={history}
			onDownloadTrace={handleDownloadTrace}
			onForceCriteria={handleForceCriteria}
		/>
	);
	return (
		<div className={styles.container}>
			<HeaderRow headers={headers} />
			<div className={styles.list__history}>
				<InfiniteList2 request={infiniteListRequest} rowRenderer={rowRenderer} />
			</div>
		</div>
	);
};

export default WorkFlowHistory;
